// hooks/useVideoControl.ts
import { useCallback, useRef } from "react";

export const useVideoControl = () => {
  const videoRefs = useRef<Record<string, HTMLVideoElement | null>>({});
  const visibilityTimers = useRef<Record<string, number>>({});

  const registerRef = useCallback((id: string, el: HTMLVideoElement | null) => {
    videoRefs.current[id] = el;
  }, []);

  const handleVideoPlayIntent = useCallback((id: string, showButtonsCb: () => void) => {
    // Show buttons after a short delay but do NOT pause the video
    // if (visibilityTimers.current[id]) {
    //   window.clearTimeout(visibilityTimers.current[id]);
    // }
    showButtonsCb();
    // visibilityTimers.current[id] = window.setTimeout(() => {
    //   // Keep the video playing; no automatic pause here
    //   delete visibilityTimers.current[id];
    // }, 500);
  }, []);

  const clearTimersOutsideWindow = useCallback((activeIndex: number, items: { id: string }[]) => {
    const startIndex = Math.max(0, activeIndex - 3);
    const endIndex = Math.min(items.length - 1, activeIndex + 3);
    Object.keys(visibilityTimers.current).forEach((id) => {
      const idx = items.findIndex((it) => it.id === id);
      if (idx === -1 || idx < startIndex || idx > endIndex) {
        window.clearTimeout(visibilityTimers.current[id]);
        delete visibilityTimers.current[id];
      }
    });
  }, []);

  const playPauseByIndex = useCallback((activeIndex: number, items: { id: string }[]) => {
    items.forEach((it, i) => {
      const v = videoRefs.current[it.id];
      if (!v) return;
      try {
        if (i === activeIndex) v.play?.();
        else v.pause?.();
      } catch { }
    });
  }, []);

  const cleanup = useCallback(() => {
    Object.values(visibilityTimers.current).forEach((t) => window.clearTimeout(t));
    visibilityTimers.current = {};
  }, []);

  return {
    registerRef,
    handleVideoPlayIntent,
    clearTimersOutsideWindow,
    playPauseByIndex,
    cleanup,
    videoRefs: videoRefs.current,
  };
};
